/**
 * This function returns an array of ordered objects
 * that will properly funnel into the keyboard help
 * Panel's Tables. The order matches the layout required
 * in the UX specifiations.
 */
export function createTableStrings(strings) {
  return [{
    action: strings.toggle.selectMode.actionText,
    shortcut: strings.toggle.selectMode.shortcutText
  }, {
    action: strings.cellNavigation.up.actionText,
    shortcut: strings.cellNavigation.up.shortcutText
  }, {
    action: strings.cellNavigation.down.actionText,
    shortcut: strings.cellNavigation.down.shortcutText
  }, {
    action: strings.cellNavigation.left.actionText,
    shortcut: strings.cellNavigation.left.shortcutText
  }, {
    action: strings.cellNavigation.right.actionText,
    shortcut: strings.cellNavigation.right.shortcutText
  }, {
    action: strings.toggle.selectedRow.actionText,
    shortcut: strings.toggle.selectedRow.shortcutText
  }, {
    action: strings.moveSelectedRows.up.actionText,
    shortcut: strings.moveSelectedRows.up.shortcutText
  }, {
    action: strings.moveSelectedRows.toTop.actionText,
    shortcut: strings.moveSelectedRows.toTop.shortcutText
  }, {
    action: strings.moveSelectedRows.down.actionText,
    shortcut: strings.moveSelectedRows.down.shortcutText
  }, {
    action: strings.moveSelectedRows.toBottom.actionText,
    shortcut: strings.moveSelectedRows.toBottom.shortcutText
  }, {
    action: strings.clearSelectedRows.actionText,
    shortcut: strings.clearSelectedRows.shortcutText
  }];
}